import TextField from 'material-ui/TextField'
import { default as SEVERITY_ICONS } from 'components/icons/SeverityIcons'

import './fixedTemplate.scss'

export default class FixedTemplate extends React.Component {
  static propTypes = {
    checklist:         React.PropTypes.array.isRequired,
    formula:           React.PropTypes.array.isRequired,
    variables:         React.PropTypes.object,
    onChange:          React.PropTypes.func.isRequired,
    onInstructionView: React.PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      showInstructions: {},
    }
  }

  setVariable(key, value) {
    const { onChange, variables } = this.props
    const newVariables = {
      ...variables,
      [key]: value,
    }

    onChange(newVariables)
  }

  showInstructions(key, truthy = true) {
    if (truthy && this.props.onInstructionView) this.props.onInstructionView()

    this.setState({
      showInstructions: {
        ...this.state.showInstructions,
        [key]: truthy,
      },
    })
  }

  checkpointSeverity(point) {
    if (!point.condition) return 'info'
    if (this.props.variables[point.condition]) return 'info'
    if (point.optional) return 'optional'

    return point.critical ? 'danger' : 'warning'
  }

  renderCheckpoint(point, key) {
    const severity = this.checkpointSeverity(point)
    const { showInstructions } = this.state

    return (
      <div className="fixedTemplate__checkpoint" key={key}>
        <div className="fixedTemplate__checkpoint__title">
          {SEVERITY_ICONS[severity]}
          <span className="text small-spacing--left">{point.text}{point.optional ? ' (optional)' : ''}</span>
          {point.instructions && !showInstructions[key] &&
            <a className="show-instructions small-spacing--left" onClick={() => this.showInstructions(key)}>View instructions</a>
          }
        </div>
        {showInstructions[key] &&
          <div className="instructions">
            <ul>
              {point.instructions.map((instruction, index) => (
                <li key={`instruction-${index}`}>{instruction}</li>
              ))}
            </ul>
            <a className="hide-instructions" onClick={() => this.showInstructions(key, false)}>Hide instructions</a>
          </div>
        }
      </div>
    )
  }

  renderChecklist() {
    return (
      <div className="fixedTemplate__checklist">
        {this.props.checklist.map((point, index) => this.renderCheckpoint(point, `checkpoint-${index}`))}
      </div>
    )
  }

  renderFormulaItem(item) {
    const key = `formula-${item.key}`

    if (item.fixed || item.separator) {
      const text = item.separator ? item.template : item.text

      return (
        <div className={`fixedTemplate__formula__item fixed ${item.static ? 'static' : ''}`} key={key}>
          {text}
        </div>
      )
    }

    return (
      <div className="fixedTemplate__formula__item dynamic" key={key}>
        <TextField
          placeholder={item.text}
          name={key}
          fullWidth
          multiLine
          value={this.props.variables[item.key]}
          onChange={({ target: { value } }) => this.setVariable(item.key, value)}
        />
        {item.hint && <div className="hint">{item.hint}</div>}
      </div>
    )
  }

  renderFormula() {
    return (
      <div className="fixedTemplate__formula">
        {this.props.formula.map(item => this.renderFormulaItem(item))}
      </div>
    )
  }

  render() {
    return (
      <div className="fixedTemplate">
        {this.renderChecklist()}
        {this.renderFormula()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/templates/FixedTemplate.js